<template>
    <v-dialog
      v-if="unit"
      v-model="dialog"
      @keydown.esc="close"
      content-class="qmkey-qunit-popup-not-mobile"
    >
       <div 
        class="background-white"
        :class="is_mobile ? 'qmkey-qunit-popup' : ''"
       >
        <!-- SITE LOGO -->
        <v-toolbar color="white" :elevation="0" >
          <div
            class="h-100"
            v-if="logo"
          >
            <img
              class="qmkey-toolbar-img"
              :src="centro_logo"
              @error="failed_logo_event"
            />
          </div>  

          <div
            v-if="title"
          >
            <span>
              {{ title }}
            </span>
          </div>  

          <v-spacer></v-spacer>

          <!-- CLOSE BUTTON -->
          <v-btn
            :elevation="0"
            @click="close"
            color="white"
            icon
            rounded
          >
            <v-icon color="primary">mdi-close</v-icon>
          </v-btn>
          
        </v-toolbar>
        <v-divider class="divider-line"></v-divider>
        <div class="qmkey-qunit-view">
          <div class="qmkey-unit-card" v-if="card">
            <Card
              :unit="unit"
              :columns="columns"
              :elevation="0"
              :actions="actions"
              :navigate="navigate"
              :is_mobile="is_mobile"
              @navigate_to="navigate_to"
              @update="(filters) => update_row(props.item, filters)"
              @update-qunit="update_qunit"
              @update-qunit-at="update_qunit"
            />
          </div>
          <InlineViewer
              v-if="unit.inline_boxes"
              class="ma-1"
              ref="inlineview"
              :name="'inlineviewer_'+unit.uid"
              :unit="unit"
              :tabs="tabs"
              @update="update_qunit"
          />
        </div>
      </div>
    </v-dialog>
</template>
  
<style lang="scss">
  @import '@/sass/explorer.scss';
  @import '@/sass/modalform.scss';
  .qmkey-qunit-view {
    margin: 0em;
    padding: 0em;
    background-color: white;
  }
  .divider-line {
    color: $primary
  }
  .qmkey-qunit-return {
    color: $primary;
    font-size: small;
  }
  .qmkey-qunit-popup {
    margin: 0;
    top: 0;
    left: 0;
    position: fixed;
    height: 100vh;
    width: 100vw;
    background-color: white;
    overflow: auto;
  }
  .qmkey-toolbar-img {
    width: auto;
    height: 100%;
  }
  .h-100 {
    height: 100%;
  }
  .qmkey-qunit-popup-not-mobile {
    max-width: 70%;
  }
  .background-white {
    background-color: white;
  }
</style>
    
    
<script>
  import QUnit from '@/qunit/QUnit';
  import { QUnitField } from '@/qunit/QFields';
  import QUnitCollection from '@/qunit/QUnitCollection';
  import Field from '@/components/qfields/Field';
  import Actions from '@/components/explorer/actions/Actions';
  import { downloadFile } from '@/utils/browserfiles';
  import { mapState, mapGetters } from 'vuex';
  import Card from '@/components/explorer/Card';
  import InlineViewer from '@/components/explorer/inline/InlineViewer';
   import { resolve_logo } from '@/utils/logos';


  export default {
    name: 'MobileQUnitView',
    
    components: {
      Card,
      InlineViewer,
    },
    
    props: {
      unit: {}, 
      columns: {default: null},
      actions: {type: Boolean, default: false},
      navigate: {type: Boolean, default: false},
      logo: {type: Boolean, default: false},
      title: {type: String, default: ''},
      card: {type: Boolean, default: false},
      tabs: {type: Boolean, default: true},
      inline: {type: Boolean, default: false},
    },
    
    data: () => ({
      dialog: false,
      failed_logo: false,
      inline_states: {}, // {uid: inline.export_state()}
    }),
    
    computed: {
      ...mapGetters(['sitePath', 'user', 'site_data', 'centro_data']),
      ...mapState(['is_mobile',]),
  
      site_logo() {
       const logo = this.site_data.logo || require('@/assets/logo_earcon.gif');
       return this.failed_logo ? require('@/assets/image_not_found.png') : logo;
     },
      centro_logo() {
        return resolve_logo(this.centro_data.logo, this.failed_logo);
     },
     
    },
    
    methods: {
      open(){
        this.dialog = true;
        this.$nextTick(() => {
          if (this.unit) {
            this.push_inline_state(this.unit.uid);
          }
        })
      },
      close(){
        this.pull_inline_state();
        this.dialog = false;
      },

      navigate_to() {
        this.close()
        this.$emit('navigate_to',this.unit);
     },

      failed_logo_event() {
        this.failed_logo = true;
      },

      update_qunit(new_qunit) {
        this.$emit('update-qunit', new_qunit);
      },

      update_row(unit, filters) {
        this.local_filters.merge(filters);
        this.$emit('update', this.local_filters);
      },

      push_inline_state(){
        // Pushes the state to the inline of the qunit uid.
        // If no state exsits, does nothing
        if (!this.$refs.inlineview || !this.unit.inline_boxes && this.unit) {
          return ;
        }
        if (this.inline_states[this.unit.uid]) {
          this.$refs.inlineview.import_state(this.inline_states[this.unit.uid]);
        } else {
          this.$refs.inlineview.import_state({tab: 0});
        }
      },
      pull_inline_state(){
        // Pulls the inline state and saves it into this.inline_states
        if (this.unit && this.$refs.inlineview && this.unit.inline_boxes) {
          this.inline_states[this.unit.uid] = this.$refs.inlineview.export_state();
        }
      },

    },
    watch: {
      unit(new_unit) {
        if (new_unit) {
          this.pull_inline_state();
          this.push_inline_state(new_unit.uid);
        }
      },

    },
  }
</script>
    
